import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';

import dataLayerEvents from '../../components/dataLayerEvents/dataLayerEvents';

export default class extends Controller {
    static values = {
        minQueryLength: { type: Number, default: 3 },
        url: { type: String },
    };

    static targets = ['input', 'results'];

    async initialize() {
        this.component = await getComponent(this.element);

        this.component.on('render:finished', () => {
            this.#focusInput();
            dataLayerEvents.refreshDOM(this.resultsTarget);
        });
        this.component.on('loading.state:finished', () => {
            dataLayerEvents.refreshDOM(this.resultsTarget);
        });
        window.addEventListener('top-search:re-render', () => {
            dataLayerEvents.refreshDOM(this.resultsTarget);
        });
    }

    toSearchPage(event) {
        const url = new URL(this.urlValue);
        url.searchParams.set('query', event.params.query ?? this.inputTarget.value);
        window.dataLayer.push({
            event: 'refonte_2025',
            eventName: 'Moteur de recherche',
            eventType: 'Navigation',
            eventLab: 'Voir tous les résultats',
            eventAct: '',
            eventCat: '',
            eventContext: '',
        });
        window.location.assign(url);
    }

    #focusInput = () => {
        this.inputTarget?.focus();
    };

    sendSuggestionSelectedEvent(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'refonte_2025',
            eventName: 'Moteur de recherche',
            eventType: 'Navigation',
            eventCat: 'Suggestions de recherche',
            eventAct: '',
            eventLab: event.currentTarget?.getAttribute('data-live-selected-param') ?? '',
            eventContext: '',
        });
    }
}
